import React from 'react';
import { getDomainConfig } from '../config';
import './LegalPage.css';

function TermsPage() {
  const config = getDomainConfig();
  const domain = window.location.hostname;

  return (
    <div className="legal-page">
      <h1>Terms and Conditions</h1>
      <p className="last-updated">Last Updated: October 2025</p>

      <div className="legal-content">
        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using {config.name} (the "Service"), you accept and agree to be bound
            by these Terms and Conditions. If you do not agree to these terms, please do not use our Service.
          </p>
        </section>

        <section>
          <h2>2. Use of Service</h2>
          <p>You agree to use the Service only for lawful purposes and in accordance with these Terms.</p>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Service in any way that violates applicable laws or regulations</li>
            <li>Impersonate or attempt to impersonate the Company or another user</li>
            <li>Engage in any conduct that restricts or inhibits anyone's use of the Service</li>
            <li>Use any automated system to access the Service without our permission</li>
          </ul>
        </section>

        <section>
          <h2>3. Products and Services</h2>
          <p>
            We strive to provide accurate product descriptions and pricing. However, we do not warrant
            that product descriptions, pricing, or other content is accurate, complete, or error-free.
          </p>
          <p>
            We reserve the right to refuse or cancel any order for any reason, including product
            availability, errors in pricing or product information, or suspected fraud.
          </p>
        </section>

        <section>
          <h2>4. Pricing and Payment</h2>
          <p>
            All prices are subject to change without notice. Payment must be made in full before
            products are shipped unless otherwise agreed upon.
          </p>
        </section>

        <section>
          <h2>5. Intellectual Property</h2>
          <p>
            The Service and its original content, features, and functionality are owned by {config.name}
            and are protected by international copyright, trademark, and other intellectual property laws.
          </p>
        </section>

        <section>
          <h2>6. Limitation of Liability</h2>
          <p>
            In no event shall {config.name}, its directors, employees, or agents be liable for any
            indirect, incidental, special, consequential, or punitive damages arising out of or relating
            to your use of the Service.
          </p>
        </section>

        <section>
          <h2>7. Disclaimer of Warranties</h2>
          <p>
            The Service is provided on an "AS IS" and "AS AVAILABLE" basis without warranties of any kind,
            either express or implied.
          </p>
        </section>

        <section>
          <h2>8. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the United States,
            without regard to its conflict of law provisions.
          </p>
        </section>

        <section>
          <h2>9. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify users of any material
            changes by posting the new Terms on this page.
          </p>
        </section>

        <section>
          <h2>10. Contact Information</h2>
          <p>
            If you have any questions about these Terms, please contact us at:
          </p>
          <p>Email: legal@{domain}</p>
          <p>Phone: 1-800-LEGAL</p>
        </section>
      </div>
    </div>
  );
}

export default TermsPage;
